<div class="med_no_search_input_container" [ngClass]="{ med_search_home_input: isSearchHome }">
  <div
    class="med_search_input_container d-flex align-items-center position-relative w-100"
    [ngClass]="{ med_searchHome_input_container: isSearchHome, med_header_search_container: !isSearchHome }"
  >
    <div class="w-100 position-relative d-flex align-items-center justify-content-end h-100 gap-3">
      <form class="w-100 h-100 position-relative" [formGroup]="searchForm" (ngSubmit)="search()">
        <app-icon icon="smart-search" class="med_search-icon" />
        <textarea
          id="searchInput"
          data-cy="med_search_input"
          [placeholder]="'search_things' | translate"
          name="text"
          rows="1"
          cols="10"
          formControlName="query"
          wrap="soft"
          (keyup)="onKeyup($event)"
          (paste)="adjustInputHeight($event)"
          (keydown.enter)="search(); $event.preventDefault()"
        ></textarea>
      </form>
      <div class="med_search-buttons-wrapper d-flex justify-content-end align-items-center">
        @if (searchForm.get("query")?.value) {
          <button
            (click)="resetQuery($event)"
            data-cy="med_search_clear_btn"
            class="med_clear_search_icon animate__animated animate__fadeIn"
          >
            <app-icon icon="xmark"></app-icon>
          </button>
        }
        <button
          type="submit"
          data-cy="med_search_submit_btn"
          class="btn btn-primary med_search_btn d-flex justify-conent-center align-items-center p-0 rounded-circle"
          (click)="search()"
        >
          <app-icon icon="arrow-search" class="icon-light flex-shrink-0" />
        </button>
      </div>
    </div>
  </div>
</div>
